/**
 * Do not edit directly
 * Generated on Thu, 26 Jun 2025 16:03:54 GMT
 */

export const DdsColorPaletteGrey3 = "#00040f";
export const DdsColorPaletteGrey10 = "#14161f";
export const DdsColorPaletteGrey20 = "#2b2f3b";
export const DdsColorPaletteGrey25 = "#3a3c46";
export const DdsColorPaletteGrey30 = "#474a52";
export const DdsColorPaletteGrey45 = "#6e7079";
export const DdsColorPaletteGrey50 = "#797c86";
export const DdsColorPaletteGrey60 = "#95979e";
export const DdsColorPaletteGrey75 = "#bbbcc2";
export const DdsColorPaletteGrey88 = "#dedfe4";
export const DdsColorPaletteGrey93 = "#ebecef";
export const DdsColorPaletteGrey98 = "#f8f8fa";
export const DdsColorPaletteGrey100 = "#ffffff";
export const DdsColorPaletteBlue10 = "#090033";
export const DdsColorPaletteBlue20 = "#110165";
export const DdsColorPaletteBlue30 = "#1a0198";
export const DdsColorPaletteBlue43 = "#2401da";
export const DdsColorPaletteBlue50 = "#2a01fe";
export const DdsColorPaletteBlue59 = "#2f6aff";
export const DdsColorPaletteBlue70 = "#6692ff";
export const DdsColorPaletteBlue80 = "#99b6ff";
export const DdsColorPaletteBlue90 = "#ccdbff";
export const DdsColorPaletteBlue95 = "#e5edff";
export const DdsColorPaletteGreen10 = "#03301c";
export const DdsColorPaletteGreen20 = "#06603c";
export const DdsColorPaletteGreen32 = "#0a9959";
export const DdsColorPaletteGreen43 = "#0ecb76";
export const DdsColorPaletteGreen50 = "#0fe182";
export const DdsColorPaletteGreen60 = "#40f2a2";
export const DdsColorPaletteGreen70 = "#81f3c4";
export const DdsColorPaletteGreen82 = "#b1f1e2";
export const DdsColorPaletteGreen90 = "#cffce8";
export const DdsColorPaletteGreen94 = "#e2fdf1";
export const DdsColorPaletteLime10 = "#183300";
export const DdsColorPaletteLime20 = "#366501";
export const DdsColorPaletteLime30 = "#479801";
export const DdsColorPaletteLime40 = "#95cb01";
export const DdsColorPaletteLime50 = "#bffd11";
export const DdsColorPaletteLime64 = "#cdfe48";
export const DdsColorPaletteLime73 = "#dafe76";
export const DdsColorPaletteLime80 = "#e4fe9a";
export const DdsColorPaletteLime90 = "#ebffcc";
export const DdsColorPaletteLime95 = "#f5ffe5";
export const DdsColorPaletteOrange10 = "#2b0d08";
export const DdsColorPaletteOrange20 = "#561910";
export const DdsColorPaletteOrange33 = "#8e2a1a";
export const DdsColorPaletteOrange38 = "#c23200";
export const DdsColorPaletteOrange50 = "#ff4200";
export const DdsColorPaletteOrange60 = "#ff6631";
export const DdsColorPaletteOrange70 = "#ffb068";
export const DdsColorPaletteOrange80 = "#ffca99";
export const DdsColorPaletteOrange90 = "#ffe4cc";
export const DdsColorPaletteOrange95 = "#fff1e5";
export const DdsColorPalettePink10 = "#33001c";
export const DdsColorPalettePink20 = "#660039";
export const DdsColorPalettePink33 = "#a8005e";
export const DdsColorPalettePink44 = "#e0007d";
export const DdsColorPalettePink55 = "#ff1a99";
export const DdsColorPalettePink66 = "#ff54b3";
export const DdsColorPalettePink70 = "#ff66bb";
export const DdsColorPalettePink80 = "#ff99d2";
export const DdsColorPalettePink90 = "#ffcce8";
export const DdsColorPalettePink95 = "#ffe5fa";
export const DdsColorPalettePurple10 = "#190033";
export const DdsColorPalettePurple20 = "#330165";
export const DdsColorPalettePurple30 = "#4c0198";
export const DdsColorPalettePurple40 = "#6606c6";
export const DdsColorPalettePurple50 = "#8008f7";
export const DdsColorPalettePurple60 = "#a533ff";
export const DdsColorPalettePurple75 = "#c780ff";
export const DdsColorPalettePurple80 = "#d299ff";
export const DdsColorPalettePurple90 = "#e9ccff";
export const DdsColorPalettePurple95 = "#f4e5ff";
export const DdsColorPaletteRed10 = "#330000";
export const DdsColorPaletteRed20 = "#660000";
export const DdsColorPaletteRed33 = "#a80000";
export const DdsColorPaletteRed43 = "#db0000";
export const DdsColorPaletteRed50 = "#ff0000";
export const DdsColorPaletteRed60 = "#ff3333";
export const DdsColorPaletteRed75 = "#ff8282";
export const DdsColorPaletteRed86 = "#ffb8b8";
export const DdsColorPaletteRed90 = "#ffcccc";
export const DdsColorPaletteRed95 = "#ffe5e6";
export const DdsColorPaletteTeal10 = "#002833";
export const DdsColorPaletteTeal20 = "#005166";
export const DdsColorPaletteTeal30 = "#007999";
export const DdsColorPaletteTeal40 = "#099fc3";
export const DdsColorPaletteTeal49 = "#00ebfa";
export const DdsColorPaletteTeal60 = "#33daff";
export const DdsColorPaletteTeal70 = "#6dddf8";
export const DdsColorPaletteTeal80 = "#9ee9fa";
export const DdsColorPaletteTeal90 = "#cef4fd";
export const DdsColorPaletteTeal95 = "#e7f9fe";
export const DdsColorPaletteYellow10 = "#331c00";
export const DdsColorPaletteYellow20 = "#663800";
export const DdsColorPaletteYellow33 = "#a85d00";
export const DdsColorPaletteYellow44 = "#e0a500";
export const DdsColorPaletteYellow50 = "#ffbb00";
export const DdsColorPaletteYellow66 = "#ffe552";
export const DdsColorPaletteYellow75 = "#ffec80";
export const DdsColorPaletteYellow80 = "#fff099";
export const DdsColorPaletteYellow90 = "#fff7cc";
export const DdsColorPaletteYellow95 = "#fffbe5";
export const DdsColorPaletteBlack = "#00040f";
export const DdsColorPaletteWhite = "#ffffff";
export const DdsColorTextPrimaryOndefault = "#00040f";
export const DdsColorTextPrimaryOninverse = "#ffffff";
export const DdsColorTextDiminishedOndefault = "#797c86";
export const DdsColorTextDiminishedOninverse = "#bbbcc2";
export const DdsColorTextDisabledOndefault = "#bbbcc2";
export const DdsColorTextLinkDefault = "#6606c6";
export const DdsColorTextLinkHover = "#330165";
export const DdsColorTextLinkActive = "#4c0198";
export const DdsColorTextLinkDisabled = "#d299ff";
export const DdsColorTextInvalidOndefault = "#a80000";
export const DdsColorTextDangerDefault = "#a80000";
export const DdsColorTextDangerHover = "#660000";
export const DdsColorTextDangerActive = "#330000";
export const DdsColorTextDangerDisabled = "#ffb8b8";
export const DdsColorTextWarningDefault = "#a85d00";
export const DdsColorBorderControlDefault = "#bbbcc2";
export const DdsColorBorderControlHover = "#95979e";
export const DdsColorBorderControlActive = "#797c86";
export const DdsColorBorderControlDisabled = "#dedfe4";
export const DdsColorBorderControlInvalid = "#a80000";
export const DdsColorBorderDividerDefault = "#dedfe4";
export const DdsColorBorderDividerDark = "#6e7079";
export const DdsColorBorderContainerDefault = "#dedfe4";
export const DdsColorBorderNotificationCaution = "#ffbb00";
export const DdsColorBorderNotificationError = "#a80000";
export const DdsColorBorderNotificationHighlight = "#bffd11";
export const DdsColorBorderNotificationNote = "#007999";
export const DdsColorBorderNotificationSuccess = "#06603c";
export const DdsColorBorderAdmin = "#ff8282";
export const DdsColorInteractivePrimaryDefault = "#8008f7";
export const DdsColorInteractivePrimaryHover = "#6606c6";
export const DdsColorInteractivePrimaryActive = "#4c0198";
export const DdsColorInteractivePrimaryDisabled = "#e9ccff";
export const DdsColorInteractiveSecondaryDefault = "#ffffff";
export const DdsColorInteractiveSecondaryHover = "#f8f8fa";
export const DdsColorInteractiveSecondaryActive = "#ebecef";
export const DdsColorInteractiveSecondaryDisabled = "#f8f8fa";
export const DdsColorInteractiveDangerDefault = "#db0000";
export const DdsColorInteractiveDangerHover = "#a80000";
export const DdsColorInteractiveDangerActive = "#660000";
export const DdsColorInteractiveDangerDisabled = "#ffb8b8";
export const DdsColorInteractiveFocusringInner = "#ffffff";
export const DdsColorInteractiveFocusringOuter = "#00040f";
export const DdsColorInteractiveLoader = "linear-gradient(90deg, #ff8282, #8008f7, #099fc3)";
export const DdsColorRequiredindicator = "#a80000";
export const DdsColorBackgroundDefault = "#ffffff";
export const DdsColorBackgroundAlternative = "#f8f8fa";
export const DdsColorBackgroundInverse = "#14161f";
export const DdsColorBackgroundNotificationDanger = "#ffe5e6";
export const DdsColorBackgroundNotificationError = "#ffe5e6";
export const DdsColorBackgroundNotificationSuccess = "#e2fdf1";
export const DdsColorBackgroundNotificationCaution = "#fff7cc";
export const DdsColorBackgroundNotificationNeutral = "#f8f8fa";
export const DdsColorBackgroundNotificationNote = "#e7f9fe";
export const DdsColorBackgroundAdmin = "#ff8282";
export const DdsColorBackgroundHighlight = "#dafe76";
export const DdsColorIconDefault = "#00040f";
export const DdsColorIconDiminished = "#797c86";
export const DdsColorIconDanger = "#db0000";
export const DdsColorIconDisabled = "#95979e";
export const DdsColorIconSuccess = "#0a9959";
export const DdsColorIconCaution = "#ff6631";
export const DdsColorIconWarning = "#ffbb00";
export const DdsColorIconNote = "#099fc3";
export const DdsColorIconAdmin = "#ff8282";
export const DdsColorFillNotificationError = "#db0000";
export const DdsColorFillNotificationSuccess = "#0a9959";
export const DdsColorFillNotificationCaution = "#ffbb00";
export const DdsColorFillNotificationNote = "#099fc3";
export const DdsColorFillNotificationHighlight = "#bffd11";
export const DdsBorderRadiusXsmall = "1px";
export const DdsBorderRadiusSmall = "0.125rem";
export const DdsBorderRadiusMedium = "0.25rem";
export const DdsBorderRadiusContainer = "0.25rem";
export const DdsBorderRadiusControlSmall = "0.125rem";
export const DdsBorderRadiusControlMedium = "0.25rem";
export const DdsBorderRadiusChip = "0.125rem";
export const DdsBorderRadiusNotification = "1px";
export const DdsBorderWidthControl = "1px";
export const DdsBorderWidthDividerDefault = "1px";
export const DdsBorderWidthDividerDark = "1px";
export const DdsBorderWidthContainerDefault = "1px";
export const DdsBorderWidthNotification = "2px";
export const DdsBorderDividerDefault = "1px solid #dedfe4";
export const DdsBorderDividerDark = "1px solid #6e7079";
export const DdsBorderContainerDefault = "1px solid #dedfe4";
export const DdsTypographyLetterspacingDefault = "-0.0825px";
export const DdsTypographyLetterspacingBody = "-0.0825px";
export const DdsTypographyLetterspacingNumeric = "-0.2px";
export const DdsTypographyLetterspacingLabel = "-0.2px";
export const DdsTypographyLetterspacingTitle = "-0.4px";
export const DdsTypographyLineheightBodySmall = "1.3333";
export const DdsTypographyLineheightBodyCondensed = "1.143";
export const DdsTypographyLineheightBodyMedium = "1.429";
export const DdsTypographyLineheightBodyLarge = "1.25";
export const DdsTypographyLineheightBodyXlarge = "1.3333";
export const DdsTypographyLineheightControlDefault = "1";
export const DdsTypographyLineheightControlSmall = "0.75";
export const DdsTypographyLineheightDisplayDefault = "1.0455";
export const DdsTypographyLineheightTitleSmall = "1.2";
export const DdsTypographyLineheightTitleMedium = "1.286";
export const DdsTypographyFontWeightLight = 320;
export const DdsTypographyFontWeightNormal = 400;
export const DdsTypographyFontWeightMedium = 520;
export const DdsTypographyFontWeightBold = 610;
export const DdsTypographyFontWeightLabel = 560;
export const DdsTypographyFontWeightDisplay = 300;
export const DdsTypographyFontWeightTitle = 500;
export const DdsTypographyFontWeightActive = 610;
export const DdsTypographyFontFamilyDefault = "Inter, Roboto, sans-serif";
export const DdsTypographyFontFamilyTitle = "Roobert, 'Instrument Sans', Poppins, Roboto, sans-serif";
export const DdsTypographyFontFamilyMonospaced = "'Messina Sans Mono', 'Space Mono', Menlo, Consolas, mono";
export const DdsTypographyFontFeaturesNumeric = "'tnum', 'zero'";
export const DdsTypographyFontSizeSize0 = "0.75rem";
export const DdsTypographyFontSizeSize1 = "0.875rem";
export const DdsTypographyFontSizeSize2 = "1rem";
export const DdsTypographyFontSizeSize3 = "1.125rem";
export const DdsTypographyFontSizeSize4 = "1.25rem";
export const DdsTypographyFontSizeSize5 = "1.75rem";
export const DdsTypographyFontSizeSize6 = "2.75rem";
export const DdsTypographyFontSizeBodySmall = "0.75rem";
export const DdsTypographyFontSizeBodyMedium = "0.875rem";
export const DdsTypographyFontSizeBodyLarge = "1rem";
export const DdsTypographyFontSizeBodyXlarge = "1.125rem";
export const DdsTypographyFontSizeControlDefault = "0.875rem";
export const DdsTypographyFontSizeControlSmall = "0.75rem";
export const DdsTypographyFontSizeDisplayDefault = "2.75rem";
export const DdsTypographyFontSizeTitleSmall = "1.25rem";
export const DdsTypographyFontSizeTitleMedium = "1.75rem";
export const DdsTypographyFontBodySmall = "normal 400 0.75rem/1.3333 Inter, Roboto, sans-serif";
export const DdsTypographyFontBodyMedium = "400 0.875rem/1.429 Inter, Roboto, sans-serif";
export const DdsTypographyFontBodyLarge = "400 1rem/1.25 Inter, Roboto, sans-serif";
export const DdsTypographyFontBodyXlarge = "320 1.125rem/1.3333 Inter, Roboto, sans-serif";
export const DdsTypographyFontTitleSmall = "500 1.25rem/1.2 Roobert, 'Instrument Sans', Poppins, Roboto, sans-serif";
export const DdsTypographyFontTitleMedium = "500 1.75rem/1.286 Roobert, 'Instrument Sans', Poppins, Roboto, sans-serif";
export const DdsTypographyFontDisplayDefault = "300 2.75rem/1.0455 Roobert, 'Instrument Sans', Poppins, Roboto, sans-serif";
export const DdsTypographyFontControlDefault = "400 0.875rem/1 Inter, Roboto, sans-serif";
export const DdsTypographyFontLabelSmall = "560 0.75rem/1.3333 Inter, Roboto, sans-serif";
export const DdsTypographyFontLabelMedium = "560 0.875rem/1.429 Inter, Roboto, sans-serif";
export const DdsTypographyFontLabelLarge = "560 1rem/1.25 Inter, Roboto, sans-serif";
export const DdsShadowDropXsmall = "0px 2px 0px 0px rgba(0, 4, 15, 0.08)";
export const DdsShadowDropSmall = "0px 1px 4px 0px rgba(0, 4, 15, 0.24), 0px 0.5px 1px 0px rgba(0, 4, 15, 0.16)";
export const DdsShadowDropMedium = "0px 2px 8px 0px rgba(0, 4, 15, 0.24), 0px 0.5px 2px 0px rgba(0, 4, 15, 0.16)";
export const DdsShadowDropLarge = "0px 4px 16px 0px rgba(0, 4, 15, 0.16), 0px 1px 4px 0px rgba(0, 4, 15, 0.16)";
export const DdsShadowBorderControlDefault = "0 0 0 1px inset #bbbcc2";
export const DdsShadowBorderControlHover = "0 0 0 1px inset #95979e";
export const DdsShadowBorderControlActive = "0 0 0 1px inset #797c86";
export const DdsShadowBorderControlDisabled = "0 0 0 1px inset #dedfe4";
export const DdsShadowBorderControlInvalid = "0 0 0 1px inset #a80000";
export const DdsShadowFocusring = "0 0 0 1px #ffffff, 0 0 0 3px #00040f";
export const DdsOutlineDefault = "2px solid #00040f";
export const DdsOutlineOffset = "1px";
export const DdsSpaceHalfx = "0.125rem";
export const DdsSpace1x = "0.25rem";
export const DdsSpace2x = "0.5rem";
export const DdsSpace3x = "0.75rem";
export const DdsSpace4x = "1rem";
export const DdsSpace5x = "1.25rem";
export const DdsSpace6x = "1.5rem";
export const DdsSpace8x = "2rem";
export const DdsSpace10x = "2.5rem";
export const DdsSpace12x = "3rem";
export const DdsSpace16x = "4rem";
export const DdsSpace18x = "4.5rem";
export const DdsSpace20x = "5rem";
export const DdsSpace24x = "6rem";
export const DdsSpace32x = "8rem";
export const DdsAnimationDurationDefault = "0.15s";
export const DdsAnimationEasingDefault = "cubic-bezier(0.83, 0, 0.17, 1)";
export const DdsSizeControlSmall = "1.25rem";
export const DdsSizeControlHalfsmall = "1.75rem";
export const DdsSizeControlMedium = "2.25rem";
export const DdsSizeIconSmall = "0.75rem";
export const DdsSizeIconMedium = "1rem";
export const DdsSizeIconLarge = "1.25rem";
